export default __webpack_public_path__ + "static/media/12-BB-(2-2).f0a33cbc.jpg";